import ServiceDetailPage from '../components/services/ServiceDetailPage';
import { getServicePageConfig } from '../data/services/servicesRegistry';

const BulkSupplyService = () => (
  <ServiceDetailPage {...getServicePageConfig('bulkSupply')} />
);

export default BulkSupplyService;
